module.exports = __webpack_public_path__ + "img/card-bg-blue.fc77434.000ab36b.png";